import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import API from "../../../helpers/API";
import jwt from "jwt-decode";
// Login Redux States
import {
  LOGIN_USER,
  LOGOUT_USER,
  SOCIAL_LOGIN,
  REGISTER_PUBLIC_USER,
} from "./actionTypes";
import { apiError, loginSuccess, logoutUserSuccess } from "./actions";

import { postSocialLogin } from "../../../helpers/fakebackend_helper";
import NotificationManager from "../../../components/Common/NotificationManager";
import apiAuth from "../../../helpers/ApiAuth";

const postJwtLogin = async (email, password) =>
  await API.post("/api/Auth/", {
    userName: email,
    password: password,
  })
    .then((authUser) => authUser.data)
    .catch((error) => {
      if (error.response.status === 400) {
        return { message: "Incorrect Credentials" };
      } else if (error.response.status === 401) {
        return { message: error.response.data.Error };
      }
      return error;
    });

const postGetGoogleToken = async (gtoken) =>
  await API.post("/api/get-token", {
    gtoken: gtoken,
  })
    .then((authUser) => authUser.data)
    .catch((error) => {
      if (error.response.status === 401) {
        return { message: "Incorrect Credentials" };
      }
      return error;
    });

function* loginUser({ payload: { user, history, type } }) {
  try {
    if (type) {
      const loginUser = yield call(postGetGoogleToken, user.credential);
      if (!loginUser.message) {
        sessionStorage.setItem("authUser", JSON.stringify(loginUser));
        localStorage.setItem("authUser", JSON.stringify(loginUser));
        localStorage.setItem("jwt", loginUser.token);
        localStorage.setItem("jwtRefresh", loginUser.token);
        yield put(loginSuccess(loginUser));

        history.push("/dashboard");
      } else {
        yield put(apiError(loginUser.message));
      }
    } else {
      const loginUser = yield call(postJwtLogin, user.userName, user.password);

      if (!loginUser.message) {
        const payload_data = atob(loginUser.split(".")[1]);
        var jwt_payload = JSON.parse(payload_data);

        const username =
          jwt_payload &&
          jwt_payload[
            "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"
          ];
        localStorage.setItem("username", username);
        localStorage.setItem("jwt", loginUser);
        yield put(loginSuccess(loginUser));

        history.push("/dashboard");
      } else {
        yield put(apiError(loginUser.message));
      }
    }
  } catch (error) {
    yield put(apiError(error));
  }
}

function* logoutUser() {
  try {
    sessionStorage.removeItem("authUser");
    localStorage.clear();
    yield put(logoutUserSuccess(LOGOUT_USER, true));
  } catch (error) {
    yield put(apiError(LOGOUT_USER, error));
  }
}

function* socialLogin({ payload: { data, history, type } }) {
  try {
    const response = yield call(postSocialLogin, data);
    sessionStorage.setItem("authUser", JSON.stringify(response));
    yield put(loginSuccess(response));
    history.push("/dashboard");
  } catch (error) {
    yield put(apiError(error));
  }
}

const postJwtPublicUser = async (
  // username,
  password,
  email,
  first_name,
  last_name,
  company_name,
  company_email,
  company_address,
  state,
  country,
  mobile
) =>
  await API.post("/api/signup/", {
    password: password,
    email: email,
    first_name: first_name,
    last_name: last_name,
    company_name: company_name,
    company_email: company_email,
    company_address: company_address,
    state: state,
    country: country,
    mobile: mobile,
  })
    .then((authUser) => authUser)
    .catch((error) => {
      if (error.response.status === 401) {
        return { message: "Incorrect Credentials" };
      } else if (error.response.status === 400) {
        return { message: error.response.data.Error };
      }
      return error;
    });

function* registerPublicUser({ payload: { user, history } }) {
  try {
    const regUser = yield call(
      postJwtPublicUser,
      user.password,
      user.email,
      user.first_name,
      user.last_name,
      user.company_name,
      user.company_email,
      user.company_address,
      user.state,
      user.country,
      user.mobile
    );
    if (regUser?.message) {
      yield put(apiError(regUser.message));
    } else {
      NotificationManager.success(
        "",
        "Registered successfully.",
        3000,
        null,
        null,
        ""
      );
      history.push("/login");
    }
  } catch (error) {
    yield put(apiError(error));
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser);
  yield takeLatest(SOCIAL_LOGIN, socialLogin);
  yield takeEvery(LOGOUT_USER, logoutUser);
  yield takeEvery(REGISTER_PUBLIC_USER, registerPublicUser);
}

export default authSaga;
